import {
    SERVICE_REPORT_LOADING,
    FETCH_SERVICE_REPORT_BY_ID_SUCCESS,
    FETCH_SERVICE_REPORT_BY_ID_ERROR,
    CLEAR_SERVICE_REPORT_BY_ID_ERROR,
    UPLOAD_SERVICE_REPORT_UPLOAD_PICTURE,
    UPLOAD_SERVICE_REPORT_UPLOAD_DEFICIENCY_FORM,
    UPLOAD_SERVICE_REPORT_UPLOAD_SIGN_OFF_FORM,
    DELETE_IMAGE_SUCCESS
} from "api/menu/reporting/actions";

const initialState = {
    loading: false,
    errors: [],
    currentServiceReport: {}
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SERVICE_REPORT_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case FETCH_SERVICE_REPORT_BY_ID_SUCCESS:
            return {
                ...state,
                errors: [],
                currentServiceReport: action.payload
            };
        case FETCH_SERVICE_REPORT_BY_ID_ERROR:
            return {
                ...state,
                errors: action.payload
            };
        case CLEAR_SERVICE_REPORT_BY_ID_ERROR:
            return {
                loading: false,
                errors: [],
                currentServiceReport: {}
            };
        case UPLOAD_SERVICE_REPORT_UPLOAD_PICTURE:
        case UPLOAD_SERVICE_REPORT_UPLOAD_DEFICIENCY_FORM:
        case UPLOAD_SERVICE_REPORT_UPLOAD_SIGN_OFF_FORM:
        case DELETE_IMAGE_SUCCESS:
            // eslint-disable-next-line no-case-declarations
            const currentServiceReport = Object.assign({}, state.currentServiceReport);

            currentServiceReport.images = action.payload;

            return {
                loading: false,
                currentServiceReport
            };
        default:
            return state;
    }
}
